import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getCriticalCareOptionsSelector, getVitalOptionsSelector } from '../../options/selectors'
import { ICriticalCareOptionsState, IVitalOptionsState } from '../../options/store/options.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import {
  setAction,
  setAssessedBy,
  setAttempts,
  setDateTime,
  setDefaultValuesForIABP,
  setSuccessfulAttempt,
} from '../../procedures/criticalCare/store/criticalCare.actions'
import { getUserIdSelector } from '../../user/selectors'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { QuickActionsConstants } from '../store/quickActions.constants'
import { CriticalCareConstants } from '../../procedures/criticalCare/store/criticalCare.constants'

export function* setCriticalCareQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  const criticalCareOptionsState: ICriticalCareOptionsState = yield select(getCriticalCareOptionsSelector)
  const { actionOptions } = criticalCareOptionsState

  try {
    if (props.procId) {
      const getActionOption = actionOptions.find((actionObj) => actionObj.id === props.procId)
      if (getActionOption) {
        yield put(setAction(getActionOption))
      }
    }
    if (props.procId === CriticalCareConstants.IABP_MAINTENANCE) {
      yield put(setDefaultValuesForIABP())
    }
    yield put(setDateTime(savedTimeString, currentDate))
    yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
    yield put(setSuccessfulAttempt(true))
    yield put(setAttempts('1'))
  } catch (e) {
    yield put(throwPcrException(`setCriticalCareQuickAction() error: ${e}`))
  }
}

export function* setCriticalCareQuickActionSaga() {
  yield takeLatest(
    [QuickActionsConstants.SET_IS_CRITICAL_CARE_BUTTON_TYPE],
    performWithMutexHOG,
    setCriticalCareQuickAction
  )
}
